import React from "react";
import { Button, CircularProgress } from "@mui/material";
import styles from "./Buttons.module.scss";

const PrimaryButton = ({
  children,
  isLoading,
  disabled,
  startIcon,
  sx,
  className,
  ...props
}) => {
  const buttonClassName = [styles.buttonBase, styles.primaryButton, className]
    .filter(Boolean)
    .join(" ");

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={isLoading || disabled}
      disableElevation
      startIcon={isLoading ? undefined : startIcon}
      className={buttonClassName}
      sx={sx}
      {...props}
    >
      {isLoading ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  );
};

export default PrimaryButton;
